export default __webpack_public_path__ + "static/media/mw7.16a1f011.webp";